import styled from '@emotion/styled';

import { inputWidths } from './helpers';
import { InputSizeX } from '.';

// Local Typings
interface Props {
  /**
   * @deprecated wrap the input in a container with the desired width
   */
  inputSizeX?: InputSizeX;
}

// Component Definition
const Wrapper = styled.div<Props>(props => ({
  maxWidth: inputWidths[props.inputSizeX ?? 'full'],
  minWidth: inputWidths[props.inputSizeX ?? 'xs'],
  position: 'relative',
  width: '100%',
}));

export default Wrapper;
